import { LogLevel, ILogger } from "@microsoft/signalr";

export class SignalRLogger implements ILogger {
	log(logLevel: LogLevel, message: string) {
		if(logLevel === LogLevel.Error && (message.includes('WebSocket closed with status code: 1006 (no reason given).') || message.includes('Server timeout elapsed without receiving a message from the server'))) {
			console.warn(message); // seems to be a common occurrence after which a reconnect can happen without problems, so don't spam sentry with this...
		}
		else if(logLevel >= LogLevel.Error) {
			console.error(message);
		}
	}
}
